import {watch} from 'vue';

import {useI18n} from '@/shared/lib/i18n';

import * as api from '../api';

import {useUserProfile} from "./useUserProfile";

// Эффект один на приложение: watch в нескольких местах отправил бы столько же запросов
let isSyncStarted = false;

/**
 * Догоняет язык на бэке, если профиль пришёл с языком, отличным от выбранного в интерфейсе.
 * Вызывать один раз — в setup App.vue.
 */
export function useProfileLocaleSync() {
    if (isSyncStarted) return;
    isSyncStarted = true;

    const {locale} = useI18n();
    const {profile} = useUserProfile();

    watch(profile, (currentProfile) => {
        if (currentProfile && currentProfile.lang != locale.value) {
            api.saveUserLocale(locale.value).then()
        }
    });
}
